import React, { useState, useMemo } from 'react'
import {
    List, Datagrid, Filter, Toolbar,DateInput, SaveButton, Button, SimpleForm, useRefresh, SelectInput, required, FormDataConsumer, useNotify, TextInput, TextField, EditButton, BulkDeleteButton, FunctionField, DeleteButton, useRecordContext, Link
} from 'react-admin'
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'

import IconCancel from "@material-ui/icons/Cancel";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from "@material-ui/core/Grid";
import { DigitalTaskStatusSelectInput,AdminUserSelectInput,UserTeamSelectInput } from '../../UI/Input/SelectInput'

const ListFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <AdminUserSelectInput label="Admin User" source="adminuser" alwaysOn />
        <DigitalTaskStatusSelectInput label="Status" source="status" alwaysOn />
        <DateInput source="current_date" lable="Date" alwaysOn/>
        <UserTeamSelectInput label="Team" source="team_type" alwaysOn/>
    </Filter>
)
const SanitizedGrid = ({ basePath, ...props }) => {
    return <Grid {...props} />;
};
const FormToolbar = props => (
    <Toolbar {...props} >
        <SaveButton label="Submit" redirect={null} submitonenter={false} />
        {!props.saving && <Button label="ra.action.cancel" onClick={props.onCancel}>
            <IconCancel />
        </Button>}
    </Toolbar>
)

const ProfileidFiled = (props) => {
    const record = useRecordContext();
    return (
        <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event) => event.stopPropagation()} />
    )
}


const AddOnTaskList = ({ ...props }) => {


    // const [open, setOpen] = useState(false);
    // const refresh = useRefresh()
    // const notify = useNotify()
    // const recordold = useRecordContext();
    // // const {onClose, record } = this.props
    // const [inputValue, setInputValue] = useState('');
    // const [selectedId, setSelectedId] = useState(null);
    // const [recordStatus, setRecordStatus] = useState(null);

    // const handleOpenDialog = (record) => {
    //     console.log(record);
    //     console.log('record');
    //     setSelectedId(record.id);
    //     setRecordStatus(record.status);
    //     setOpen(true);
    // }
    // const handleCloseDialog = () => setOpen(false);


    // // Function to handle submit action in the dialog
    // const handleSubmit = (record) => {

    //     const data = {
    //         "rid": selectedId,
    //         "status": record.status,
    //         "reason": record.decline_reason
    //     }
    //     actionOfAddOnTask(data, selectedId, (res) => {
    //         refresh()
    //         notify(res.message)
    //     }, (res) => {
    //         notify(res.message, 'warning')
    //     })
    //     setOpen(false);

    // };

    // const OpenDialogButton = ({ onClick }) => {
    //     const record = useRecordContext(); // Access the current record context
    //     if (!record) return null; // Ensure record exists
    //     return (

    //         <Button style={{ color: 'purple', border: '1px solid' }} onClick={() => onClick(record)} label="Update Action" size="small"></Button>
    //     );
    // };


    // const choices = useMemo(() => {

    //     if (recordStatus === 'Pending') {
    //         return [
    //             { id: 'Approved', name: 'Approved' },
    //             { id: 'Rejected', name: 'Rejected' },
    //         ];
    //     } else if (recordStatus === 'Approved') {
    //         return [
    //             { id: 'Pending', name: 'Pending' },
    //             { id: 'Rejected', name: 'Rejected' },
    //         ];
    //     } else {
    //         return [
    //             { id: 'Pending', name: 'Pending' },
    //             { id: 'Approved', name: 'Approved' },
    //         ];
    //     }
    // }, [recordStatus]);


    return (
        <List {...props} title="Video Task"  filters={<ListFilter />} sort={{ field: 'title', order: 'ASC' }}>

            <Datagrid >
                <TextField source="id" />
                <ProfileidFiled source="profile_id" label="Profile Id" />
                <TextField source='name' label="Name" />
               
                <FunctionField source="status" label="Status" render={record => {

                    if (record['status'] === 'Rejected') {
                        return (<span style={{ color: 'red' }}>Reject</span>)
                    } else if (record['status'] === 'Pending') {
                        return (<span style={{ color: 'orange' }} >Pending</span>)
                    }
                    else {
                        return (<span style={{ color: 'green' }}>Approved</span>)
                    }
                }} />
                <TextField source="amount" label="Amount" />
                <TextField source="start_code" label="Start Code" />
                <TextField source="end_code" label="End Code" />
                <TextField source="company_name" label="Company Name" />
                <TextField source="understand_advertisement" label="Understand Advertisement" />
                <TextField source="ads_showing" label="Ads Showing " />
                 <TextField source="product_rating" label="Product Rating " />

                 <TextField source="recommend" label="Recommend" />
                
                <TextField source='created_at' label="Date" />
               

            </Datagrid>

         

        </List>
    )
}


export default AddOnTaskList 